module.exports = __webpack_public_path__ + "img/20328378.1ca77095.png";